<script setup lang="ts">
type Props = {
  organizationLogo: string;
  organizationName: string;
};

defineProps<Props>();
</script>

<template>
  <header
    class="h-[72px] px-5 flex items-center gap-3 md:border-b md:border-border-subtle md:px-12 shrink-0"
  >
    <img
      :src="organizationLogo"
      :alt="organizationName"
      class="w-8 h-8 rounded-full md:w-10 md:h-10"
    />
    <p class="font-medium text-foreground-emphasis text-mgm-txt-sm">
      {{ organizationName }}
    </p>
  </header>
</template>
